import React from 'react';
import ClassNames from 'classnames';
import { KEY_VALUES } from '../utils';
import { useLocalization } from "@appkit4/react-api";
var Header = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var id = _ref.id,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'transparent' : _ref$type,
    _ref$hasLogo = _ref.hasLogo,
    hasLogo = _ref$hasLogo === void 0 ? true : _ref$hasLogo,
    onClickLogo = _ref.onClickLogo,
    titleTemplate = _ref.titleTemplate,
    subTitleTemplate = _ref.subTitleTemplate,
    contentTemplate = _ref.contentTemplate,
    optionsTemplate = _ref.optionsTemplate,
    userTemplate = _ref.userTemplate,
    _ref$compact = _ref.compact,
    compact = _ref$compact === void 0 ? false : _ref$compact,
    _ref$responsive = _ref.responsive,
    responsive = _ref$responsive === void 0 ? true : _ref$responsive,
    ariaLabel = _ref.ariaLabel,
    _ref$role = _ref.role,
    role = _ref$role === void 0 ? 'link' : _ref$role,
    _ref$hamburgerPositio = _ref.hamburgerPosition,
    hamburgerPosition = _ref$hamburgerPositio === void 0 ? '' : _ref$hamburgerPositio,
    onClickHamburger = _ref.onClickHamburger,
    style = _ref.style,
    className = _ref.className;
  var _useLocalization = useLocalization(),
    t = _useLocalization.t;
  var classes = ClassNames('ap-header', className, {
    'ap-header-responsive-default': !compact && responsive,
    'ap-header-responsive-manual': compact,
    'solid': type === 'solid'
  });
  var optionRef = React.useRef(null);
  var headingRef = React.useRef(null);
  var menuIcon = function menuIcon() {
    return /*#__PURE__*/React.createElement("div", {
      className: "ap-header-options-item hamburger hamburger-button-icon",
      tabIndex: 0
    }, /*#__PURE__*/React.createElement("svg", {
      className: "icon icon-menu-toggle",
      width: "16",
      height: "9",
      viewBox: "0 0 16 9",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/React.createElement("g", {
      className: "svg-menu-toggle"
    }, /*#__PURE__*/React.createElement("path", {
      className: "line line-1",
      d: "M16 8.89599H0V7.90399H16V8.89599Z"
    }), /*#__PURE__*/React.createElement("path", {
      className: "line line-2",
      d: "M16 4.992H0V4H16V4.992Z"
    }), /*#__PURE__*/React.createElement("path", {
      className: "line line-3",
      d: "M16 1.08801H0V0.0960083H16V1.08801Z"
    }))));
  };
  var bindRefEvent = function bindRefEvent(optionRef) {
    var hamburgerNode = optionRef && optionRef.querySelector('.hamburger-button-icon');
    if (hamburgerNode) {
      // @ts-ignore
      hamburgerNode.onclick = function (event) {
        this.classList.toggle("opened");
        onClickHamburger === null || onClickHamburger === void 0 ? void 0 : onClickHamburger(event);
      };
    }

    // if (optionRef?.querySelector('.hamburger-button-icon')) {
    //   // @ts-ignore
    //   (optionRef?.querySelector('.hamburger-button-icon') as HTMLElement).onclick = function (event: React.MouseEvent<HTMLElement>) {
    //     // @ts-ignore
    //     (this as HTMLElement).classList.toggle("opened");
    //     onClickHamburger?.(event);
    //   }
    // }
  };

  React.useEffect(function () {
    var _optionRef$current2, _headingRef$current2;
    var eventHandler = function eventHandler(event) {
      if (event.key === KEY_VALUES.ENTER) {
        var _optionRef$current, _headingRef$current;
        // @ts-ignore
        var hamburgerIcon = ((_optionRef$current = optionRef.current) === null || _optionRef$current === void 0 ? void 0 : _optionRef$current.querySelector('.hamburger-button-icon')) || ((_headingRef$current = headingRef.current) === null || _headingRef$current === void 0 ? void 0 : _headingRef$current.querySelector('.hamburger-button-icon'));
        hamburgerIcon === null || hamburgerIcon === void 0 ? void 0 : hamburgerIcon.classList.toggle("opened");
        onClickHamburger === null || onClickHamburger === void 0 ? void 0 : onClickHamburger(event);
      }
    };
    optionRef === null || optionRef === void 0 ? void 0 : (_optionRef$current2 = optionRef.current) === null || _optionRef$current2 === void 0 ? void 0 : _optionRef$current2.addEventListener('keydown', eventHandler);
    headingRef === null || headingRef === void 0 ? void 0 : (_headingRef$current2 = headingRef.current) === null || _headingRef$current2 === void 0 ? void 0 : _headingRef$current2.addEventListener('keydown', eventHandler);
    return function () {
      var _optionRef$current3, _headingRef$current3;
      optionRef === null || optionRef === void 0 ? void 0 : (_optionRef$current3 = optionRef.current) === null || _optionRef$current3 === void 0 ? void 0 : _optionRef$current3.removeEventListener('keydown', eventHandler);
      headingRef === null || headingRef === void 0 ? void 0 : (_headingRef$current3 = headingRef.current) === null || _headingRef$current3 === void 0 ? void 0 : _headingRef$current3.removeEventListener('keydown', eventHandler);
    };
  }, []);
  React.useEffect(function () {
    if (hamburgerPosition === 'right') bindRefEvent(optionRef.current);else if (hamburgerPosition === 'left') bindRefEvent(headingRef.current);
  }, [hamburgerPosition]);
  return /*#__PURE__*/React.createElement("header", {
    id: id,
    ref: ref,
    style: style,
    className: classes
  }, /*#__PURE__*/React.createElement("div", {
    // @ts-ignore 
    ref: headingRef,
    className: "ap-header-heading"
  }, hamburgerPosition === 'left' && responsive && menuIcon(), hasLogo && /*#__PURE__*/React.createElement("div", {
    tabIndex: 0,
    role: role,
    "aria-label": ariaLabel || t("aria").pwcLogoLabel,
    onClick: onClickLogo
  }, /*#__PURE__*/React.createElement("div", {
    className: "ap-header-logo"
  })), titleTemplate && /*#__PURE__*/React.createElement("div", {
    className: "ap-header-title"
  }, titleTemplate()), subTitleTemplate && /*#__PURE__*/React.createElement("div", {
    className: "ap-header-subtitle"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ap-header-subtitle-divider"
  }), subTitleTemplate())), contentTemplate && /*#__PURE__*/React.createElement("div", {
    className: "ap-header-content " + (hamburgerPosition !== '' ? "hamburger-hidden" : "")
  }, contentTemplate()),
  // @ts-ignore
  (optionsTemplate || userTemplate) && /*#__PURE__*/React.createElement("div", {
    ref: optionRef,
    className: "ap-header-options " + (hamburgerPosition !== '' ? "hamburger-hidden" : "")
  }, optionsTemplate === null || optionsTemplate === void 0 ? void 0 : optionsTemplate(), hamburgerPosition === 'right' && responsive && menuIcon(), /*#__PURE__*/React.createElement("div", {
    className: hamburgerPosition !== '' ? "hamburger-hidden-user" : ""
  }, userTemplate === null || userTemplate === void 0 ? void 0 : userTemplate())));
});
Header.displayName = 'Header';
export default Header;